import { Modal } from '@shared/components/modals/Modal';
import { ModalContentContainer } from '@shared/styledComponents';

interface IVoicemailPreviewProps {
  onClose: () => void;
  isOpen: boolean;
  voicemail: unknown;
  previewVoicemailPosition: number;
}

const demoLink = 'https://cdn.freesound.org/previews/663/663274_1089955-lq.mp3';

export const VoicemailPreviewModal = ({ onClose, isOpen, previewVoicemailPosition }: IVoicemailPreviewProps) => (
  <Modal
    hideBackdrop
    title="Voicemail Preview (for demo"
    open={isOpen} 
    resetPosition={previewVoicemailPosition}
    onClose={onClose}
  >
    <ModalContentContainer>
      <audio controls>
        <source src={demoLink} type="audio/mpeg" />
      </audio>
    </ModalContentContainer>
  </Modal>
);
